import repository from '@/services/searchRepository';
import dxCustomStore from 'devextreme/data/custom_store';

export default new dxCustomStore({
    key: 'objectId',
    load: (loadOptions) => {
        return repository.getSearchData(loadOptions.searchValue).then((result: any) => {
            const searchResults = result;
            return {
                data: searchResults.data,
            };
        });
    },

  byKey: (val: any) => {
        return repository.getSearchData(val).then((result: any) => {
            return result;
        });
    },
  });
